import React, { useState, useEffect, useCallback } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";

const EmptyNavBar = () => {
  return (
    <>
      <Navbar expand="lg" variant="dark" style={{ backgroundColor: "#000000" }}>
        <Container>
        <Navbar.Brand as={Link} to="/login">
          {process.env.REACT_APP_ENV === 'demo' && 
            <Image className="navbar-brand" src="logo-demo.png" alt="Logo" fluid />
          }
            {process.env.REACT_APP_ENV === 'production' && 
            <Image className="navbar-brand" src="logo.png" alt="Logo" fluid />
          }

          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
};
export default EmptyNavBar;



